module.exports = __webpack_public_path__ + "static/media/delete.ba2faae0.svg";